import React from "react";

const pillars = [
    {
        icon: "🎓",
        kicker: "Sin intermediarios",
        title: "Acceso directo a instituciones educativas de Canadá",
        items: [
            "Habla directamente con representantes y reclutadores de instituciones educativas canadienses.",
            "Obtén información de primera mano, sin intermediarios.",
            "Conoce programas, fechas de inscripción, colegiaturas y opciones de beca.",
            "Resuelve tus dudas en el momento, con quien toma las decisiones."
        ]
    },
    {
        icon: "💼",
        kicker: "Asesor laboral especializado",
        title: "Oportunidades laborales reales en Canadá",
        items: [
            "Cómo encontrar oportunidades de empleo de verdad.",
            "Qué requisitos están buscando hoy los empleadores canadienses.",
            "Estrategias para aumentar tus posibilidades de conseguir trabajo.",
            "Los errores más comunes que debes evitar."
        ]
    },
    {
        icon: "🍁",
        kicker: "Consultor regulado por el Gobierno de Canadá",
        title: "Asesoría migratoria con un consultor regulado",
        items: [
            "Habla con un consultor migratorio regulado por el Gobierno de Canadá.",
            "Conoce la mejor estrategia migratoria según tu perfil.",
            "Identifica cuál es la provincia más conveniente para ti.",
            "Entiende cómo empezar bien el trámite y qué opciones hay para quedarte a largo plazo."
        ]
    }
];

function Pillars() {
    return (
        <div className="pillars__grid">
            {pillars.map((pillar, index) => (
                <article className="pillar" key={pillar.title}>
                    <div className="pillar__head">
                        <span className="pillar__number">{index + 1}</span>
                        <span className="pillar__icon" aria-hidden="true">{pillar.icon}</span>
                    </div>
                    <span className="pillar__kicker">{pillar.kicker}</span>
                    <h3>{pillar.title}</h3>
                    <ul className="list-unstyled">
                        {pillar.items.map((item) => (
                            <li key={item}>
                                <span aria-hidden="true">✅</span>
                                <span>{item}</span>
                            </li>
                        ))}
                    </ul>
                </article>
            ))}
        </div>
    );
}

export default Pillars;
